(function () {
  const CUSTOM_EVENT_PREFIX = "pod_storefront";
  const IMPRESSION_EVENT = `${CUSTOM_EVENT_PREFIX}:content_impression`;
  const INTERACTION_EVENT = `${CUSTOM_EVENT_PREFIX}:content_interaction`;
  const ENGAGEMENT_EVENT = `${CUSTOM_EVENT_PREFIX}:engaged_time`;
  const IMPRESSION_THRESHOLD = 0.5;
  const HEARTBEAT_SECONDS = 15;
  const seenSlots = new Set();
  let engagedSeconds = 0;
  let heartbeatCount = 0;
  let heartbeatTimer = null;

  function analyticsPublish(name, payload) {
    const analytics = window.Shopify && window.Shopify.analytics;
    if (!analytics || typeof analytics.publish !== "function") {
      return;
    }
    analytics.publish(name, payload);
  }

  function asNumber(value) {
    if (value === null || value === undefined || value === "") {
      return null;
    }
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }

  function referrerClassification() {
    try {
      const referrer = document.referrer ? new URL(document.referrer) : null;
      if (!referrer) {
        return "direct";
      }
      if (referrer.host === window.location.host) {
        return "internal";
      }
      if (/facebook|instagram|meta/i.test(referrer.host)) {
        return "meta";
      }
      if (/google|bing|duckduckgo|yahoo/i.test(referrer.host)) {
        return "search";
      }
      return "external";
    } catch {
      return "unknown";
    }
  }

  function buildPayload(element, extras) {
    const data = element.dataset || {};
    const url = new URL(window.location.href);
    return {
      slotId: data.podSlot || null,
      slotType: data.podSlotType || null,
      slotLabel: data.podSlotLabel || null,
      listingSlot: data.podListingSlot || data.podSlot || null,
      creativeId: data.podCreativeId || null,
      creativeName: data.podCreativeName || null,
      creativeType: data.podCreativeType || null,
      collectionHandle: data.podCollectionHandle || null,
      productId: data.podProductId || null,
      productHandle: data.podProductHandle || null,
      variantId: data.podVariantId || null,
      productPosition: asNumber(data.podProductPosition),
      productFamily: data.podProductFamily || null,
      designTheme: data.podDesignTheme || null,
      campaignContent: url.searchParams.get("utm_content"),
      experimentId: data.podExperimentId || null,
      cohort: data.podCohort || null,
      referrerClassification: referrerClassification(),
      destinationUrl: data.podDestinationUrl || null,
      ...extras,
    };
  }

  function pageType() {
    const path = window.location.pathname || "/";
    if (path === "/") return "home";
    if (path.startsWith("/products/")) return "product";
    if (path.startsWith("/collections/")) return "collection";
    if (path.startsWith("/search")) return "search";
    if (path.startsWith("/cart")) return "cart";
    if (path.startsWith("/checkout")) return "checkout";
    return "page";
  }

  function emitImpression(element, ratio) {
    const slotId = element.dataset && element.dataset.podSlot;
    if (!slotId || seenSlots.has(slotId)) {
      return;
    }
    seenSlots.add(slotId);
    analyticsPublish(
      IMPRESSION_EVENT,
      buildPayload(element, {
        visibleRatio: ratio,
        interactionType: "impression",
      }),
    );
  }

  function emitInteraction(element, interactionType, destinationUrl) {
    analyticsPublish(
      INTERACTION_EVENT,
      buildPayload(element, {
        interactionType,
        destinationUrl: destinationUrl || element.dataset.podDestinationUrl || null,
      }),
    );
  }

  function observeSlots() {
    const slots = Array.from(document.querySelectorAll("[data-pod-slot]"));
    if (slots.length === 0) {
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting && entry.intersectionRatio >= IMPRESSION_THRESHOLD) {
          emitImpression(entry.target, entry.intersectionRatio);
        }
      }
    }, {threshold: [IMPRESSION_THRESHOLD]});

    for (const slot of slots) {
      observer.observe(slot);
      slot.addEventListener("click", (event) => {
        const target = event.target instanceof Element ? event.target.closest("a, button, [data-pod-track-click]") : null;
        const destinationUrl = target && target instanceof HTMLAnchorElement ? target.href : null;
        const interactionType = target && target.tagName === "BUTTON" ? "button_click" : "click";
        emitInteraction(slot, interactionType, destinationUrl);
      });
    }
  }

  function emitEngagement() {
    heartbeatCount += 1;
    engagedSeconds += HEARTBEAT_SECONDS;

    const activeSlot = document.querySelector("[data-pod-slot][data-pod-product-id]") || document.querySelector("[data-pod-slot]");
    const payload = activeSlot ? buildPayload(activeSlot, {}) : {
      productId: null,
      productHandle: null,
      listingSlot: null,
      referrerClassification: referrerClassification(),
      campaignContent: new URL(window.location.href).searchParams.get("utm_content"),
    };

    analyticsPublish(ENGAGEMENT_EVENT, {
      ...payload,
      engagedTimeSeconds: engagedSeconds,
      heartbeatCount,
      pageVisible: document.visibilityState === "visible",
      pageFocused: document.hasFocus(),
      pageType: pageType(),
      pagePath: window.location.pathname || null,
      derivedFrom: "theme_visibility_heartbeat",
    });
  }

  function startHeartbeat() {
    if (heartbeatTimer !== null) {
      return;
    }
    heartbeatTimer = window.setInterval(() => {
      if (document.visibilityState === "visible" && document.hasFocus()) {
        emitEngagement();
      }
    }, HEARTBEAT_SECONDS * 1000);
  }

  function stopHeartbeat() {
    if (heartbeatTimer !== null) {
      window.clearInterval(heartbeatTimer);
      heartbeatTimer = null;
    }
  }

  function bindHeartbeatLifecycle() {
    startHeartbeat();
    document.addEventListener("visibilitychange", startHeartbeat);
    window.addEventListener("focus", startHeartbeat);
    window.addEventListener("pageshow", startHeartbeat);
    window.addEventListener("beforeunload", stopHeartbeat);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      observeSlots();
      bindHeartbeatLifecycle();
    }, {once: true});
  } else {
    observeSlots();
    bindHeartbeatLifecycle();
  }
})();
